import * as React from 'react';
import { createPortal } from 'react-dom';
import { DMDiv } from '../Primitives';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  className?: string;
}

export const Modal = ({
  isOpen,
  onClose,
  children,
  className = 'z-[999]',
}: ModalProps) => {
  if (!isOpen) return null;
  return createPortal(
    <DMDiv
      className={`fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm transition-opacity ${className}`}
      onClick={onClose}
    >
      <DMDiv
        className="relative w-full max-w-md transform rounded-2xl bg-white p-8 text-center shadow-2xl transition-all"
        onClick={e => e.stopPropagation()}
      >
        {children}
      </DMDiv>
    </DMDiv>,
    document.body,
  );
};
